<template>
  <div class="guess" v-if="!!title || productlist.length > 0">
    <p v-if="!!title" class="van-divider">{{ title }}</p>
    <div class="list" v-if="productlist && productlist.length > 0">
      <product-item
        class="item"
        v-for="(item, index) of productlist"
        :key="index"
        :prolistItem="item"
        :skuSwitch="skuSwitch"
        @addCartHandler="addCartHandler"
        :markPointData="markPointData"
      ></product-item>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import productItem from './productItem'
import { isApp, exclusiveidFn, pointParams } from '../../assets/common/js/config'
export default {
  name: 'productList',
  components: {
    productItem
  },
  props: {
    markPointData: {
      // 埋点用
      type: Object,
      default: function () {
        return {}
      }
    },
    title: {
      type: String,
      default: ''
    },
    productlist: {
      type: Array,
      default: function () {
        return []
      }
    },
    type: {
      type: String,
      default: '0'
    },
    skuSwitch: {
      type: String,
      default: '0'
    }
  },
  methods: {
    addCartHandler() {
      this.$emit('addCartHandler')
    },
    guessClick: function (items, index) {
      var id = items.itemid ? items.itemid : items.item_base_id
      // 首页流量位则进行埋点
      if (this.type == 1) {
        this.dataCollection(items, index, '猜你喜欢')
      }
      var arg = isApp()
      if (arg == '') {
        this.$router.push({
          path: '/productdetail',
          query: {
            itemid: id
          }
        })
      } else if (arg.indexOf('xcx') >= 0) {
        wx.miniProgram.navigateTo({
          url:
            '/pages/product/main?itemid=' +
            id +
            '&exclusiveid=' +
            exclusiveidFn() +
            pointParams('&')
        })
      } else {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'goItemDetail',
            itembaseid: id
          })
        )
      }
    },
    // 埋点-猜你喜欢
    dataCollection(items, index, flowArea) {
      let params = {
        flowArea_var: flowArea, // 区域
        position_var: index, // 坑位
        flowName_var: flowArea, // 流量位名称
        productName_var: items.name || '' // 商品名称
      }
      // 首页-流量位-埋点事件
      gio('track', 'flowLocationClick', params)
      // 首页-流量位-区域-转化变量
      gio('evar.set', 'flowArea_evar', flowArea)
      // 首页-流量位-区域-坑位-转化变量
      let value = items.name || ''
      gio('evar.set', 'flowName_evar', value)
    }
  }
}
</script>

<style scoped lang="scss">
.guess {
  background: #fff;
  /*padding-bottom: 0.3rem;*/
  > p {
    color: #222222;
    font-size: 0.18rem;
    text-align: center;
    padding-top: 0.03rem;
    display: flex;
    display: -moz-flex;
    display: -o-flex;
    display: -ms-flex;
    display: -webkit-flex;
    justify-content: center;
    -moz-justify-content: center;
    -o-justify-content: center;
    -ms-justify-content: center;
    -webkit-justify-content: center;
    span {
      display: block;
      color: #dbdbdb;
    }
  }
  .van-divider {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    width: 60%;
    margin: 0 auto;
    line-height: 24px;
    border-color: #dbdbdb;
    border-style: solid;
    border-width: 0;
    color: #222222;
    font-weight: 400;
  }
  .van-divider::before,
  .van-divider::after {
    content: ' ';
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    box-sizing: border-box;
    height: 1px;
    border-color: inherit;
    border-style: inherit;
    border-width: 1px 0 0;
    margin-right: 16px;
    margin-left: 16px;
  }
  .list {
    /*padding: 0 0.11rem;*/
    display: flex;
    flex-wrap: wrap;
    padding: 0.06rem 0 0.2rem;
    .item {
      &:nth-of-type(1),
      &:nth-of-type(2) {
        padding-top: 0;
        margin-top: 0.08rem;
      }
      &:nth-of-type(2n-1) {
        padding-right: 0.05rem;
      }
      &:nth-of-type(2n) {
        padding-left: 0.05rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/productList.vue